import { DishAllergen, DishDisclaimers } from "api-types";

import React from "react";

import { Stack, Typography, useTheme } from "@mui/material";

import { AllergenChipOutlined } from "../../Chip/Chip";
import { ExpandableAllergen } from "../../ExpandableAllergen/ExpandableAllergen";
import { useFilterMenu } from "../filters";

interface DishInfoMayContainProps {
  hasFilteredAllergensOrIngredient: boolean;
  allergenDisclaimers: DishDisclaimers[];
  matchedMayContainAllergens: DishAllergen[];
}

export const DishInfoMayContain = ({
  allergenDisclaimers,
  hasFilteredAllergensOrIngredient,
  matchedMayContainAllergens,
}: DishInfoMayContainProps) => {
  const {
    palette: { oscar },
  } = useTheme();
  const filterMenu = useFilterMenu();
  return (
    <Stack
      alignItems="center"
      display="flex"
      borderRadius={4}
      gap={1}
      paddingBottom={2}
      marginTop={1}
      sx={{
        backgroundColor: oscar.light.surface.neutral,
        padding: 4,
        width: "100%",
      }}
    >
      <Typography variant="labelRMedium">May contain:</Typography>
      {filterMenu.showMayContainAllergens &&
        !!matchedMayContainAllergens.length && (
          <Stack
            alignItems="center"
            flexDirection="row"
            flexWrap="wrap"
            justifyContent="center"
            gap={1.5}
            paddingTop={1}
          >
            {matchedMayContainAllergens.map((mayContainAllergen) => (
              <AllergenChipOutlined
                mayContain
                key={mayContainAllergen.igfdTaxAllergenId}
                allergenName={mayContainAllergen.allergenName}
              />
            ))}
          </Stack>
        )}
      <Stack gap={1.5}>
        {hasFilteredAllergensOrIngredient &&
          allergenDisclaimers.map((disclaimer, index) => (
            <ExpandableAllergen
              key={disclaimer.id}
              expanded={index === 0}
              allergen={{
                title: `${disclaimer.title}: possible allergen(s)`,
                ingredients: disclaimer.ingredients.map(
                  (ingredient) => ingredient.name
                ),
                description: disclaimer.text,
              }}
            />
          ))}
      </Stack>
    </Stack>
  );
};
